import React from "react";
import { Helmet } from "react-helmet-async";

interface TitleProps {
    desc: string
}
export default function Title({desc}: TitleProps) {
    return (
        <Helmet>
            <title>Poinguinie - {desc}</title>
        </Helmet>
    );
}